var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.732 55.309L49.763 49.065C51.509 47.147 52.583 44.607 52.583 41.815C52.583 35.862 47.74 31.019 41.787 31.019C35.834 31.019 30.991 35.862 30.991 41.815C30.991 47.768 35.834 52.61 41.787 52.61C44.228 52.61 46.475 51.786 48.286 50.414L54.287 56.691C54.483 56.896 54.746 57 55.009 57C55.258 57 55.506 56.908 55.7 56.723C56.099 56.341 56.114 55.708 55.732 55.309ZM32.991 41.814C32.991 36.964 36.937 33.018 41.787 33.018C46.637 33.018 50.583 36.964 50.583 41.814C50.583 46.664 46.637 50.61 41.787 50.61C36.937 50.61 32.991 46.664 32.991 41.814Z",
    fill: "black",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.991 12C27.438 12 26.991 12.447 26.991 13C26.991 13.553 27.438 14 27.991 14H45.991C46.544 14 46.991 13.553 46.991 13C46.991 12.447 46.544 12 45.991 12H27.991Z",
    fill: "black",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.991 27C46.991 26.447 46.544 26 45.991 26H27.991C27.438 26 26.991 26.447 26.991 27C26.991 27.553 27.438 28 27.991 28H45.991C46.544 28 46.991 27.553 46.991 27Z",
    fill: "black",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.57 7.24101C21.153 6.88201 20.519 6.92901 20.161 7.34901L13.913 14.637L10.091 11.771C9.65096 11.441 9.02396 11.528 8.69196 11.971C8.35996 12.412 8.44996 13.039 8.89196 13.37L13.463 16.799C13.642 16.934 13.853 16.999 14.062 16.999C14.345 16.999 14.625 16.88 14.822 16.649L21.679 8.64901C22.039 8.23101 21.99 7.60101 21.57 7.24101Z",
    fill: "black",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.57 21.241C21.153 20.882 20.519 20.929 20.161 21.349L13.913 28.637L10.091 25.771C9.65096 25.441 9.02396 25.528 8.69196 25.971C8.35996 26.412 8.44996 27.039 8.89196 27.37L13.463 30.799C13.642 30.934 13.853 30.999 14.062 30.999C14.345 30.999 14.625 30.88 14.822 30.649L21.679 22.649C22.039 22.231 21.99 21.601 21.57 21.241Z",
    fill: "black",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.161 36.35L13.913 43.637L10.091 40.771C9.65096 40.44 9.02396 40.528 8.69196 40.971C8.35996 41.412 8.44996 42.039 8.89196 42.37L13.463 45.799C13.642 45.934 13.853 45.999 14.062 45.999C14.345 45.999 14.625 45.88 14.822 45.649L21.679 37.65C22.039 37.231 21.991 36.6 21.571 36.241C21.153 35.882 20.519 35.93 20.161 36.35Z",
    fill: "black",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.991 52H13.167C7.55497 52 2.99097 47.436 2.99097 41.824V12.176C2.99097 6.564 7.55497 2 13.167 2H42.815C48.426 2 52.991 6.564 52.991 12.176V33C52.991 33.553 53.438 34 53.991 34C54.544 34 54.991 33.553 54.991 33V12.176C54.991 5.462 49.529 0 42.815 0H13.167C6.45297 0 0.990967 5.462 0.990967 12.176V41.824C0.990967 48.538 6.45297 54 13.167 54H26.991C27.544 54 27.991 53.553 27.991 53C27.991 52.447 27.544 52 26.991 52Z",
    fill: "black",
    fillOpacity: 0.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.bf472bfa88b92775d7f1322c1343c3b0.svg";
export { ForwardRef as ReactComponent };